import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {NgFor, NgIf} from '@angular/common';

/** Which sheet of the disconnect flow is on screen. */
export type DisconnectStep = 'confirm' | 'feedback';

/**
 * Two-step disconnect flow shown as a bottom sheet on mobile and a centered
 * dialog from `sm` up. The component is presentational: the parent owns the
 * `WhatsappService` call and drives `step`.
 */
@Component({
  selector: 'app-disconnect-whatsapp',
  standalone: true,
  imports: [NgIf, NgFor],
  templateUrl: './disconnect-whatsapp.component.html',
})
export class DisconnectWhatsappComponent {

  /** Sheet to show, or `null` to keep the flow closed. */
  @Input() step: DisconnectStep | null = null;

  /** Disables the confirm sheet's buttons while the request is in flight. */
  @Input() loading = false;

  /** Error surfaced on the confirm sheet when disconnecting fails. */
  @Input() errorMessage = '';

  /** User tapped DISCONNECT on the confirm sheet. */
  @Output() confirm = new EventEmitter<void>();

  /** User dismissed the current sheet (CANCEL, backdrop or Escape). */
  @Output() cancel = new EventEmitter<void>();

  @Output() contactSupport = new EventEmitter<void>();

  /** User picked a reason on the "What didn't work for you?" sheet. */
  @Output() feedback = new EventEmitter<string>();

  /** Reasons offered after the number has been disconnected. */
  readonly reasons = [
    'Too many messages',
    'Not useful for me',
    'I prefer app notifications',
    'I’m concerned about privacy',
    'Other',
  ];

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.step && !this.loading) {
      this.cancel.emit();
    }
  }
}
